import { Injectable } from '@angular/core';
import { Angular5Csv } from 'angular5-csv/Angular5-csv';
import * as moment from 'moment';


@Injectable()
export class CsvService {
  private options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: false,
    useBom: true,
    noDownload: false,
    headers: []
  };

  constructor() { }

  public exportFile(json: any[],  columnsName: Array<string>, fileName: string): void {
    this.options.headers = columnsName;
    new Angular5Csv(json, fileName + '_' + moment().format('YYYY-MM-DD'), this.options);
  }

}
